type Option = {
  label: string
  value: string
}

type ReturnType = 'label' | 'value'

export const convertLabelAndId = (
  type: ReturnType,
  lookFor: string,
  options: Array<Option>
): string => {
  const objectFound: Option | undefined = options.find((option) => option[type] === lookFor)
  const returnType: ReturnType = type === 'value' ? 'label' : 'value'
  return objectFound ? objectFound[returnType] : ''
}
